import React, { useEffect, useState } from "react"
import WPApiFetch from '../Utility/WPApi'
import { ParseHtml } from "../Utility/WPParser";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { getBaseURL } from '../Utility/getBaseURL'


const formID = 719;
const formDefault = () => {
	return '<span class="wpcf7-form-control-wrap your-name"><input type="text" name="your-name" placeholder="Your Name" class="wpcf7-form-control wpcf7-text" disabled="disabled" /></span><span class="wpcf7-form-control-wrap your-email"><input type="email" name="your-email" placeholder="Your Email" class="wpcf7-form-control wpcf7-text wpcf7-email" disabled="disabled" /></span><span class="wpcf7-form-control-wrap your-message"><textarea name="your-message" cols="40" rows="10" class="wpcf7-form-control wpcf7-textarea" placeholder="Your Message" disabled="disabled"></textarea></span><input type="submit" class="wpcf7-form-control wpcf7-submit" value="Send" disabled="disabled" />';
}

const ContactForm7 = () => {
	const { executeRecaptcha } = useGoogleReCaptcha();
	const [form, setForm] = useState(formDefault);
	const [formResponse, setFormResponse] = useState();
	const [loading, setLoading] = useState(true);
	const formUrl = getBaseURL() + '/wp-json/contact-form-7/v1/contact-forms/'+formID+'/feedback';

	useEffect(() => {
	    async function fetchForm() {
		   	const route = '/wp/v2/wpcf7/'+formID
			const data = await WPApiFetch(route, this)
			setForm(data.form);
			setLoading(false);
	    }
	    fetchForm();
	}, [])

	const handleSubmit = async ev => {
		ev.preventDefault();
		
		const theForm = ev.target;
		const formElements = ev.target.elements;
		const formData = new FormData();
		const token = await executeRecaptcha('token');

		var formControls = document.querySelectorAll('.wpcf7-form-control-wrap');
		formControls.forEach(function(item) {
			item.classList.remove('invalid');
		});
		document.querySelector('.wpcf7-form').classList.add('loading');
		document.querySelector('.wpcf7-form').classList.remove('invalid');
		document.querySelector('.wpcf7-form').classList.remove('failed');

		formData.append('_wpcf7_recaptcha_response', token);

		[...formElements].map(item => {
			switch(item.type) {
				case 'fieldset':
					break;
				case 'radio':
				case 'checkbox':
					if(item.checked) {
						formData.append(item.name, item.value);
					}
					break;
				default: 
					formData.append(item.name, item.value);
					break;
			}
			return null;
		})

		fetch(formUrl, { method: 'post', headers: {}, credentials:"omit", body: formData } )
			.then(async response => {
				const data = await response.json();
				//console.log(data);
				switch(data.status) {
					case "validation_failed": 
						document.querySelector('.wpcf7-form').classList.add("invalid");
						data.invalid_fields.map(item=>{
							document.querySelector(item.into).classList.add("invalid");
							return null;
						});
						break
					case "spam": 	
						document.querySelector('.wpcf7-form').classList.add("spam");
						break
					case "mail_sent": 	
						document.querySelector('.wpcf7-form').classList.add("sent");
						theForm.reset();
						break	
					default:
						break
			}
			setFormResponse(data.message)
			document.querySelector('.wpcf7-form').classList.remove('loading');
	  	}).catch( error => { return Promise.reject(error); });
	}
	return (
		<div role="form" className={"wpcf7 wpcf7-form "+(loading && "loading")} id={"wpcf7-f"+formID+"-o1"} lang="en-US" dir="ltr">
			<form action={"/#wpcf7-f"+formID+"-o1"} className="wpcf7-form" noValidate="novalidate" onSubmit={handleSubmit}>
				{ form && ParseHtml( form ) }
				{ formResponse && <div className="wpcf7-response-output">{formResponse}</div> }
				<div className="loading-overlay"><div className="loading-spinner"></div></div>
			</form>
		</div>
	)
}

export default ContactForm7